import type { GetStaticPathsResult, GetStaticPropsContext } from "next";
import { withPage } from "src/utils/pagination/with-page";
import { ProductListingView } from "src/organisms/ProductListingView";
import type {
  CollectionsProductList,
  ProductListProps,
} from "src/types/product-listing";
import { useLingui } from "@lingui/react";
import { msg } from "@lingui/macro";
import {
  getCollectionProductListProps,
  type CollectionProductListReturnType,
} from "src/utils/search-provider/get-product-list-props";
import { DEFAULT_PAGE_NOT_FOUND } from "src/utils/constants";

type CollectionPageProps = ProductListProps<CollectionsProductList>;

function CollectionPage({
  pageProps,
}: {
  pageProps: CollectionPageProps;
}): JSX.Element {
  const { i18n } = useLingui();

  const description = i18n._(
    msg`Browse all items in ${pageProps.collection?.name} for ${pageProps.gender}. Shop top brands with discounts of up to 70%. Take advantage and order today!`
  );
  return (
    <ProductListingView
      defaultSorting="POPULARITY"
      description={description}
      {...pageProps}
    />
  );
}

export function getStaticPaths(): GetStaticPathsResult {
  return {
    paths: [],
    fallback: "blocking",
  };
}

export const getStaticProps = withPage(async function getStaticProps(
  {
    params,
  }: GetStaticPropsContext<{
    slug: string;
    collectionSlug: string[];
  }>,
  page
): CollectionProductListReturnType {
  if (!params || !params.slug || !params.collectionSlug.length) {
    return DEFAULT_PAGE_NOT_FOUND;
  }

  return getCollectionProductListProps({
    gender: params.slug,
    slug: params.collectionSlug,
    page,
  });
});

export default CollectionPage;
